import { defineComponent as _defineComponent } from 'vue'
import { reactive, toRefs } from "vue";
import { ReviewerAttributeAnswerPostRequest } from "@/apiRequests/models/communityTalk/reviewerAttributeAnswerPostRequest";
import { ReviewerAttributeDto } from "@/apiRequests/models/communityTalk/talkRoomGetResponse";

interface State {
	/**
	 * 選択された投稿者プロフィールID
	 */
	reviewerAttributeId: string;
	/**
	 * 選択された投稿者プロフィール選択肢ID
	 */
	attributeChoiceId: string;
}

// reactiveな変数宣言
interface Props {
	/**
	 * 投稿者プロフィールデータ。
	 */
	reviewerAttribute: ReviewerAttributeDto;
	/**
	 * プリセット用の投稿者プロフィールデータ。
	 */
	reviewerAttributePreset: ReviewerAttributeAnswerPostRequest | undefined;
	/**
	 * 識別子ID。
	 * 各投稿者プロフィール投稿フォームでinputタグのID値を分別化するために使用。
	 */
	uniqueKey: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
interface Emits {
	(e: "click-reviewer-attributettribute-choice", v: { reviewerAttributeId: string; attributeChoiceId: string; checked: boolean }): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    reviewerAttribute: { type: null, required: true },
    reviewerAttributePreset: { type: null, required: true },
    uniqueKey: { type: String, required: true }
  },
  emits: ["click-reviewer-attributettribute-choice"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "click-reviewer-attributettribute-choice", v: { reviewerAttributeId: string; attributeChoiceId: string; checked: boolean }): void;
}), expose: any, slots: any, attrs: any }) {
  expose()

const props = __props as {
	/**
	 * 投稿者プロフィールデータ。
	 */
	reviewerAttribute: ReviewerAttributeDto;
	/**
	 * プリセット用の投稿者プロフィールデータ。
	 */
	reviewerAttributePreset: ReviewerAttributeAnswerPostRequest | undefined;
	/**
	 * 識別子ID。
	 * 各投稿者プロフィール投稿フォームでinputタグのID値を分別化するために使用。
	 */
	uniqueKey: string;
}
/**
 * 投稿者プロフィール投稿フォーム用。
 */
const state = reactive<State>({
	reviewerAttributeId: "",
	attributeChoiceId: "",
});
const { reviewerAttributeId, attributeChoiceId } = toRefs(state);





const onclick = (element: HTMLInputElement, reviewerAttributeId: string, attributeChoiceId: string): void => {
	// 対象の直前の選択状態を取得
	const beforeChecked = isCheckedReviewerAttributeChoice(attributeChoiceId);

	// 親コンポーネントに選択された投稿者プロフィール情報を渡す
	if (beforeChecked) {
		emit("click-reviewer-attributettribute-choice", { reviewerAttributeId: reviewerAttributeId, attributeChoiceId: attributeChoiceId, checked: false });
	} else {
		emit("click-reviewer-attributettribute-choice", { reviewerAttributeId: reviewerAttributeId, attributeChoiceId: attributeChoiceId, checked: true });
	}
};

/**
 * 対象の選択肢が選択中であるかどうか。
 */
const isCheckedReviewerAttributeChoice = (reviewerAttributeChoiceId: string): boolean => {
	// プリセットデータがなければ問答無用で`false`
	if (!props.reviewerAttributePreset) {
		return false;
	}

	const findIndex = props.reviewerAttributePreset.AttributeChoiceIds.findIndex((e) => e === reviewerAttributeChoiceId);
	if (findIndex > -1) {
		return true;
	}
	return false;
};

const __returned__ = { state, reviewerAttributeId, attributeChoiceId, props, emit, onclick, isCheckedReviewerAttributeChoice }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})